/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";


export function animateLiveMarketsWheel(liveMarketsWheelRef) {
    gsap.registerPlugin(DrawSVGPlugin);
    // liveMarketsWheelRef.current.goToAndStop(0, true);

    gsap.set(".blueArrowRight__head", {
        strokeWidth: 0,
        drawSVG: "50% 50%",
    })

    const protocolTextTimeline = gsap.timeline({
        delay: 1,
        scrollTrigger: {
            trigger: ".liveMarkets__protocolTextWrapper",
            start:"bottom 90%"
        }
    });
    protocolTextTimeline.from(
        '#protocolLine',{
            duration: 0.5,
            scaleY: 0
        },
    ).add('start').fromTo(
        '#protocolTextBorder', {
            drawSVG:"50% 50%"
        }, {
            duration: 1,
            immediateRender:true,
            drawSVG:"100%"
        }, 'start'
    ).from(
        ".liveMarkets__protocolTextBackground", {
            duration: 0.5,
            autoAlpha: 0,
            y: 40,
        }, 'start+=0.2'
    ).from(
        ".liveMarkets__protocolText", {
            duration: 0.5,
            autoAlpha: 0,
            y: 40,
        }, 'start+=0.4'
    ).from(
        '.blueArrowRight__body', {
            duration: 0.5,
            drawSVG: 0
        },
    ).to('.blueArrowRight__head' , { 
            duration: 0.01,
            strokeWidth: 5 
        },
    ).to(
        '.blueArrowRight__head', {
            duration: 0.5,
            drawSVG: "0 100%",
        },
    )
    .add('end')
    .fromTo(
        '#protocolSideTextBorder', {
            drawSVG:"50% 50%"
        }, {
            duration: 1,
            immediateRender:true,
            drawSVG:"100%"
        }, 'end'
    )
    .from(
        ".liveMarkets__protocolSideTextBackground", {
            duration: 0.5,
            autoAlpha: 0,
            // x: 40,
        }, 'end+=0.2'
    )
    .from(
        ".liveMarkets__protocolSideText", {
            duration: 0.5,
            autoAlpha: 0,
            // x: 40,
        }, 'end+=0.4'
    )
    .from(
        '#protocolLine2',{
            duration: 0.5,
            scaleY: 0,  
        },
    ).add(() => {
        const liveMarketWheel = document.getElementById('liveMarkets__wheelGif')
        liveMarketWheel.src = '/public/images/liveMarkets/Wheel_Alltogether_05B_NoLoop.gif'
    }).from(
        ".liveMarkets__liveMarketsWheel", {
            duration: 1,
            autoAlpha: 0,
            y: 80
        }
    ).from(
        ".liveMarkets__liveMarketsWheel__text", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
        }
    ).from(
        ".liveMarkets__liveMarketsWheel__bottomNote", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
        }
    )
}

export function animateSpeedometerSection(speedometerLiquidityRef, speedometerSizeRef, speedometerAnonymityRef, speedometerPriceVsSpeedRef) {
    speedometerLiquidityRef.current.goToAndStop(0, true);
    speedometerSizeRef.current.goToAndStop(0, true);
    speedometerAnonymityRef.current.goToAndStop(0, true);
    speedometerPriceVsSpeedRef.current.goToAndStop(0, true);


    const speedometerLiquidity = gsap.timeline({
        scrollTrigger: {
            trigger: "#liquidityLabel",
            start: "top 80%",
            end: "bottom top",
        }
    });
    
    const speedometerSize = gsap.timeline({
        delay: 1,
        scrollTrigger: {
            trigger: "#sizeLabel",
            start: "top 80%",
            end: "bottom top",
        }
    });

    const speedometerAnonymity = gsap.timeline({
        scrollTrigger: {
            trigger: "#anonymityLabel",
            start: "top 80%",
            end: "bottom top",
        }
    });

    const speedometerPrice = gsap.timeline({
        delay: 1,
        scrollTrigger: {
            trigger: "#priceSpeedLabel",
            start: "top 80%",
            end: "bottom top",
        }
    });

    
    speedometerLiquidity.from(
        "#liquidityLabel", {
            duration: 1,
            autoAlpha: 0,
            y: 20,
            
        }
    ).add(() => {
        speedometerLiquidityRef.current.play()
    }).from(
        "#liquiditySubLabels", {
            duration: 1,
            autoAlpha: 0,
            y: 20,
            delay: 0.6,
        }
    );
    speedometerSize.from(
        "#sizeLabel", {
            duration: 1,
            autoAlpha: 0,
            y: 20,
            
        }
    ).add(() => speedometerSizeRef.current.play())
    .from(
        "#sizeSubLabels", {
            duration: 1,
            autoAlpha: 0,
            y: 20,
            delay: 0.6,
        }
    );
    
    speedometerAnonymity.from(
        "#anonymityLabel", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
            
        }
    ).add(() => speedometerAnonymityRef.current.play())
    .from(
        "#anonymitySubLabels", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
            delay: 0.6,
        }
    );
    speedometerPrice.from(
        "#priceSpeedLabel", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
            
        }
    ).add(() => speedometerPriceVsSpeedRef.current.play())
    .from(
        "#priceSpeedSubLabels", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
            delay: 0.6,
        }
    )
}

export function animateSectionTitle() {
    const speedometerTimeline1 = gsap.timeline({
        delay: 2,
    });

    gsap.registerPlugin(DrawSVGPlugin);


    const sectionTitleTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".liveMarkets__sectionTitle",
            start:"bottom bottom",
        }
    });

    sectionTitleTimeline.from(
        ".liveMarkets__sectionTitle", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
        }
    )

    speedometerTimeline1.from(
        "#speedometersTitle", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
            scrollTrigger: {
                trigger: "#liquiditySpeedometer",
                start:"top bottom",
                end:"bottom top",
            }
        }
    ).add('border').from(
        "#liveMarkets__speedometersGrid", {
            duration: 1,
            autoAlpha: 0,
            y: 80,
        }, 'border+=0.5'
    ).fromTo(
        '#speedometersGridBorder', {
            drawSVG:"50% 50%"
        }, {
            duration: 2.4,
            immediateRender:true,
            drawSVG:"100%"
        }, 'border+=1'
    ).from(
        ".liveMarkets__floatingButton", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
        }, 'border+=1.6'
    );
}

export function animateIcebergSection(icebergRef, iconCheckRef, iconPlusRef, iconProcessRef, iconTicketRef) {
    icebergRef.current.goToAndStop(0, true);
    iconCheckRef.current.goToAndStop(0, true);
    iconPlusRef.current.goToAndStop(0, true);
    iconProcessRef.current.goToAndStop(0, true);
    iconTicketRef.current.goToAndStop(0, true);

    gsap.registerPlugin(DrawSVGPlugin);

    const icebergTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".liveMarkets__howItWorks__textModule-1",
            start:"bottom bottom",
        },
    });
    icebergTimeline.add('textModuleStart').fromTo(
        '#howItWorks__textModuleBorder1', {
            drawSVG:"50% 50%"
        }, {
            duration: 2,
            immediateRender:true,
            drawSVG:"100%",
        }, 'textModuleStart'
    ).from(
        ".liveMarkets__howItWorks__textModule-1", {
            duration: 1,
            autoAlpha: 0,
            y: 60,
        }, 'textModuleStart'
    ).from(
        '#howItWorksLine1',{
            duration: 1,
            scaleY: 0,
            scrollTrigger: {
                trigger: "#howItWorksLine1",
                start:"bottom 75%",
            }
        },
    ).add('start' ).from(
        "#liveMarkets__iceberg", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
        }, 'start+=0.5'
    ).fromTo(
        '#liveMarkets__icebergBorder', {
            drawSVG:"50% 50%"
        }, {
            duration: 2,
            immediateRender:true,
            drawSVG:"100%"
        }, 'start+=0.8'
    ).from(
        ".liveMarkets__iceberg__animation", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
        }, 'start+=1.2'
    ).add(() => icebergRef.current.play(), 'start+=1.4')
    .from(
        ".liveMarkets__icebergText-1", {
            duration: 0.6,
            autoAlpha: 0,
            y: 40,
        }, 'start+=1.8'
    ).from(
        ".liveMarkets__icebergText-2", {
            duration: 0.6,
            autoAlpha: 0,
            y: 40,
        }, 'start+=2.2'
    ).from(
        ".liveMarkets__icebergText-3", {
            duration: 0.6,
            autoAlpha: 0,
            y: 40,
        }, 'start+=2.6'
    ).from(
        ".liveMarkets__icebergText-4", {
            duration: 0.6,
            autoAlpha: 0,
            y: 40,
        }, 'start+=3'
    ).from(
        '.whiteArrowDown__body', {
            duration: 0.5,
            drawSVG: 0,
        },
    ).from(
        '.whiteArrowDown__head--left', {
            duration: 0.5,
            drawSVG: 0
        },
    ).from(
        '.whiteArrowDown__head--right', {
            duration: 0.5,
            drawSVG: 0
        }, '-=0.5'
    ).from(
        ".liveMarkets__howItWorks__iconModule-1", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
        }
    ).add(() => iconCheckRef.current.play()).from(
        '#howItWorksLine2',{
            duration: 1,
            scaleY: 0,
            scrollTrigger: {
                trigger: ".liveMarkets__howItWorks__iconModule-2",
                start:"bottom bottom",
            }
        },
    ).from(
        ".liveMarkets__howItWorks__iconModule-2", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
        }
    ).add(() => iconPlusRef.current.play()).from(
        '#howItWorksLine3',{
            duration: 1,
            scaleY: 0,
            scrollTrigger: {
                trigger: ".liveMarkets__howItWorks__iconModule-3",
                start:"bottom bottom",
            }
        },
    ).from(
        ".liveMarkets__howItWorks__iconModule-3", {
            duration: 1,
            autoAlpha: 0,
            y: 40
        }
    ).add(() => iconTicketRef.current.play()).from(
        '#howItWorksLine4',{
            duration: 1,
            scaleY: 0,
            scrollTrigger: {
                trigger: ".liveMarkets__howItWorks__iconModule-4",
                start:"bottom bottom",
            }
        },
    ).from(
        ".liveMarkets__howItWorks__iconModule-4", {
            duration: 1,
            autoAlpha: 0,
            y: 40
        }
    ).from(
        "#howItWorks__iconProcess", {
            duration: 1,
            autoAlpha: 0,
            opacity: 0,
            y: 40,
        }
    ).add(() => iconProcessRef.current.play());
}

export function animateSweepTheStackSection(cardSpotRef, funnelSpotRef) {
    cardSpotRef.current.goToAndStop(0, true);
    funnelSpotRef.current.goToAndStop(0, true);

    gsap.registerPlugin(DrawSVGPlugin);


    const sweepTheStackTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".liveMarkets__howItWorks__textModule-2",
            start:"bottom bottom",
        },
    });
    sweepTheStackTimeline.add('start').fromTo(
        '#howItWorks__textModuleBorder2', {
            drawSVG:"50% 50%"
        }, {
            duration: 2,
            immediateRender:true,
            drawSVG:"100%"
        }, 'start'
    ).from(
        ".liveMarkets__howItWorks__textModule-2", {
            duration: 1,
            autoAlpha: 0,
            y: 60,
        }, 'start'
    ).from(
        '#howItWorksLine5',{
            duration: 1,
            scaleY: 0,
            scrollTrigger: {
                trigger: "#howItWorksLine5",
                start:"bottom bottom",
            }
        },
    ).from(
        "#liveMarkets__cardSpot", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
        }
    ).add(() => cardSpotRef.current.play()).from(
        ".liveMarkets__tripleLines--01 .liveMarkets__tripleLine", {
            duration: 1,
            scaleY: 0,
            stagger: 0.2,
            transformOrigin: "top center",
            scrollTrigger: {
                trigger: ".liveMarkets__sweepCards",
                start:"bottom bottom",
            }
        }
    ).from(
        ".liveMarkets__sweepCard", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
            stagger: 0.2
        }
    ).from(
        ".liveMarkets__tripleLines--02 .liveMarkets__tripleLine--01", {
            duration: 0.5,
            scaleY: 0,
            transformOrigin: "top center",
        }
    ).from(
        ".liveMarkets__tripleLines--02 .liveMarkets__tripleLine--03", {
            duration: 0.5,
            scaleY: 0,
            transformOrigin: "top center",
        }, "-=0.5"
    ).from(
        ".liveMarkets__tripleLinesHorizLine--01", {
            duration: 0.5,
            scaleX: 0,
            transformOrigin: "center left",
        }
    ).from(
        ".liveMarkets__tripleLinesHorizLine--02", {
            duration: 0.5,
            scaleX: 0,
            transformOrigin: "center right",
        }, "-=0.5"
    ).from(
        ".liveMarkets__tripleLines--02 .liveMarkets__tripleLine--02", {
            duration: 0.5,
            scaleY: 0,
            transformOrigin: "top center",
        }
    ).from(
        "#liveMarkets__funnelSpot", {
            duration: 1,
            autoAlpha: 0,
            y: 40,
        }
    ).add(() => funnelSpotRef.current.play())
}

export function animateOutroSection() {
    const outroTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".liveMarkets__outroButton",
            start:"bottom bottom",
        }
    });
    outroTimeline.from(
        ".liveMarkets__outroButton", {
            duration: 1,
            autoAlpha: 0,
            y: 100,
        }
    ).from(
        ".liveMarkets__outro", {
            duration: 1,
            autoAlpha: 0,
            y: 100,
        }
    ).add('arrowStart').from(
        "#footerArrow_1", {
            duration: 0.5,
            autoAlpha: 0,
            x: -80,
            delay: 0.2,
        }, 'arrowStart'
    ).from(
        "#footerArrow_2", {
            duration: 0.5,
            autoAlpha: 0,
            x: -80,
            delay: 0.4,
        }, 'arrowStart'
    ).from(
        "#footerArrow_3", {
            duration: 0.5,
            autoAlpha: 0,
            x: -80,
            delay: 0.6,
        }, 'arrowStart'
    ).from(
        "#footerArrow_4", {
            duration: 0.5,
            autoAlpha: 0,
            x: -80,
            delay: 0.8,
        }, 'arrowStart'
    ).from(
        "#footerArrow_5", {
            duration: 0.5,
            autoAlpha: 0,
            x: -80,
            delay: 1,
        }, 'arrowStart'
    )
}



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/animationTimelines.jsx